<script setup lang="ts">
import Accordion, { type AccordionProps } from "primevue/accordion";
import IconComponent from "../IconComponent/IconComponent.vue";
import { IconName } from "@/constants";

export interface TaiAccordionProps extends AccordionProps {}
defineProps<TaiAccordionProps>();
</script>

<template>
  <Accordion
    v-bind="{ ...$props, ...$attrs }"
    unstyled
    data-testid="tai-accordion"
  >
    <template #expandicon>
      <IconComponent :name="IconName.ChevronDown"></IconComponent>
    </template>
    <template #collapseicon>
      <IconComponent :name="IconName.ChevronUp"></IconComponent>
    </template>
    <slot></slot>
  </Accordion>
</template>
